import script from "./item1.vue?vue&type=script&setup=true&lang=js"
export * from "./item1.vue?vue&type=script&setup=true&lang=js"

import "./item1.vue?vue&type=style&index=0&id=80398636&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80398636"]])

export default __exports__